import { Component } from '@angular/core';

import { BaseComponent } from 'src/app/@shared/components/abstract/base.component';
import {
    LegalConsentDialogComponent,
    LegalConsentDialogData
} from 'src/app/legal/components/legal-consent-dialog/legal-consent-dialog.component';
import { LegalDocumentTypeEnum } from 'src/app/@shared/enums/legal-document-type.enum';

@Component({
    selector: 'app-legal-footer',
    imports: [],
    templateUrl: './legal-footer.component.html',
    styleUrls: ['./legal-footer.component.scss']
})
export class LegalFooterComponent extends BaseComponent {

    public openCguDialog(event: Event): void {
        event.preventDefault();
        const data: LegalConsentDialogData = { documentType: LegalDocumentTypeEnum.CGU, mode: 'info' };
        this.openDialog(LegalConsentDialogComponent, 'LEGAL_CONSENT_DIALOG', data);
    }

    public openPrivacyDialog(event: Event): void {
        event.preventDefault();
        const data: LegalConsentDialogData = { documentType: LegalDocumentTypeEnum.PRIVACY, mode: 'info' };
        this.openDialog(LegalConsentDialogComponent, 'LEGAL_CONSENT_DIALOG', data);
    }
}
